import React from 'react';
import { CheckCircle2, ChevronDown } from 'lucide-react';
import { humanize } from './profileFields';
import { workflowDate } from './workflowPresentation';

export const WorkflowHistory = ({ view, ...props }) => <>
  {view.completed.length > 0 && <details className="profile-disclosure" data-testid="workflow-completed-tasks">
    <summary data-testid="workflow-completed-tasks-toggle">Completed tasks ({view.completed.length})<ChevronDown className="w-4 h-4" /></summary>
    {view.completed.map(t => <article key={t.id} className="text-sm py-3 flex gap-2" data-testid={`wf-completed-${t.id}`}>
      <CheckCircle2 className="w-4 h-4 text-teal-700 shrink-0 mt-0.5" aria-hidden="true" />
      <div className="min-w-0 space-y-1">
        <p className="font-medium" data-testid={`wf-completed-title-${t.id}`}>{t.title || humanize(t.type)}</p>
        <p className="text-xs text-gray-600" data-testid={`wf-completed-by-${t.id}`}>Completed by: {t.completed_by_name || (t.completed_by === 'system' ? 'System' : t.completed_by ? 'Staff member unavailable' : 'Not recorded')}{t.completed_by_name && t.completed_by_role ? ` · ${humanize(t.completed_by_role)}` : ''}</p>
        <p className="text-xs text-gray-500" data-testid={`wf-completed-time-${t.id}`}>{humanize(t.type)} · {t.completed_at ? `${workflowDate(t.completed_at)} IST` : 'Completion time not recorded'}</p>
      </div>
    </article>)}
  </details>}
</>;